/*global Modernizr, Splide, ThemeSlideCurrentSlide, ThemeSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    function ThemeSlideHideAlertArrows(Splide) {
      'use strict';

      function mount() {
        Splide.on('mounted resize', () => {
          if(Splide.length <= Splide.options.perPage) {
            Splide.root.querySelector('.splide__arrow.splide__arrow--prev').classList.add('hidden');
            Splide.root.querySelector('.splide__arrow.splide__arrow--next').classList.add('hidden');
            Splide.root.querySelector('.slider-status').classList.add('hidden');
          } else {
            Splide.root.querySelector('.splide__arrow.splide__arrow--prev').classList.remove('hidden');
            Splide.root.querySelector('.splide__arrow.splide__arrow--next').classList.remove('hidden');
            Splide.root.querySelector('.slider-status').classList.remove('hidden');
          }
        });
      }

      return {
        mount
      };
    }

    var alerts_container = document.getElementById('theme-alerts');
    if(alerts_container) {
      var alert_slider = alerts_container.querySelector('.alert-slider'),
          close_alert = alerts_container.querySelector('.alerts-close');

      const slider = new Splide(alert_slider, {
        type: 'loop',
        pagination: false
      });

      slider.on('mounted resize', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.mount({ ThemeSlideCurrentSlide, ThemeSlideHideAlertArrows, ThemeSlideDisableDrag });

      close_alert.addEventListener('click', (e) => {
        e.preventDefault();

        document.cookie = 'WPThemeClosedAlerts=true; max-age='+(12*60*60)+'; SameSite=lax; path=/';

        document.querySelector('.alerts-slider-container').remove();
        document.body.classList.add('alerts-closed');
      });
    }
}());
